import { useCallback } from "react"
import { IExtendedUsuario, IUsuario, IUsuarioTable } from "../../application/models/IUsuario"
import { IPerfil } from "../../application/models/IPerfil"
import { delay } from "../../utils/delay"
import { useAxiosInstances } from "../axios-instance"
import { ITipoUsuario } from "../../application/models"

export const useUserApi = () => {
  // Axios
  const { axiosAuthInstance } = useAxiosInstances()

  const findUsuariosByIdClienteApi = useCallback(async (data: {
    idCliente: number
    page: number
    limit: number
  }): Promise<{
    list: Omit<IUsuarioTable, "Senha">[]
    total: number
  }> => {
    try {
      const result = await axiosAuthInstance.get(`/usuario/cliente/${data.idCliente}`, {
        params: {
          Page: data.page,
          Limit: data.limit
        }
      })

      return {
        list: result.data.list,
        total: result.data.total
      }
    } catch (error) {
      throw error
    }
  }, [axiosAuthInstance])

  const getAllUsuariosAtivosByIdClienteApi = useCallback(async(data: {
    IdClienteBusca: number
  }): Promise<Omit<IUsuario, "Senha">[]> => {
    try {
      const result = await axiosAuthInstance.get(`/usuario/cliente/ativos/${data.IdClienteBusca}`)

      return result.data.usuarios
    } catch (error) {
      throw error
    }
  }, [axiosAuthInstance])

  const getUserByIdApi = useCallback(async (data: {
    idUsuario: number
  }): Promise<{
    usuario: IExtendedUsuario
  }> => {
    try {
      const result = await axiosAuthInstance.get(`/usuario/${data.idUsuario}`)
      return {
        usuario: result.data.usuario
      }
    } catch (error: any) {
      //console.error('Erro ao buscar usuário por ID:', error?.response?.data || error?.message)
      throw error
    }
  }, [axiosAuthInstance])

  const getUserPerfilApi = useCallback(async (data: {
    id: string
  }): Promise<IPerfil> => {
    const perfil: IPerfil = {
      IdPerfil: 0,
      Descricao: "",
      Ativo: true,
      Atualizacao: null,
      IdCliente: 0,
      Inclusao: new Date()
    }

    return perfil
    // await delay(1551)
    // return {
    //   id: '1',
    //   clienteId: '1',
    //   createdAt: new Date(),
    //   updatedAt: new Date(),
    //   nome: 'Perfil Teste',
    //   status: true,
    //   produtos: [
    //     {
    //       produtoId: '2',
    //       limit: 100,
    //       status: true,
    //       produto: 'Veles - Dashboard',
    //       consumos: [
    //         {
    //           nome: 'consultaObitoV1',
    //           status: true,
    //           tipoConsumoId: '1'
    //         }
    //       ]
    //     },
    //     {
    //       produtoId: '3',
    //       limit: 100,
    //       status: true,
    //       produto: 'Veles - Geo',
    //       consumos: [
    //         {
    //           nome: 'consultaObitoV1',
    //           status: true,
    //           tipoConsumoId: '1'
    //         }
    //       ]
    //     }
    //   ]
    // }
  }, [])

  const getVendedoresApi = useCallback(async (): Promise<IUsuario[]> => {
    const usuarioMock: IUsuario[] = [{
      IdUsuario: 0,
      IdCliente: 0,
      Nome: "",
      LoginUsuario: "",
      Senha: "",
      Email: "",
      Ativo: false,
      Inclusao: new Date(),
      Atualizacao: null
    }]

    return usuarioMock
  }, [])


  const createUserApi = useCallback(async (data: {
    nome: string
    email: string
    login: string
    idPerfil: number
    idCliente: number
    tipoUsuario?: ITipoUsuario
    tokenAtivo?: boolean
    idsClientes?: number[]
  }): Promise<void> => {
    try {
      const body: any = {
        Nome: data.nome,
        Email: data.email,
        Login: data.login,
        IdCliente: data.idCliente,
        IdPerfil: data.idPerfil,
        TipoUsuario: data.tipoUsuario ?? ITipoUsuario.USUARIO_CLIENTE
      }

      if (data.tokenAtivo !== undefined) {
        body.TokenAtivo = data.tokenAtivo
      }

      if (data.idsClientes !== undefined) {
        body.IdsClientes = data.idsClientes
      }

      const result = await axiosAuthInstance.post(`/usuario`, body)

      return result.data
    } catch (error) {
      throw error
    }
  }, [axiosAuthInstance])

  const updateUserApi = useCallback(async (data: {
    idUsuario: number
    nome: string
    email: string
    login: string
    ativo: boolean
    idCliente: number
    idPerfil: number
    tipoUsuario: ITipoUsuario
    token?: string
    tokenAtivo?: boolean
    idsClientes?: { IdCliente: number; Ativo: boolean }[]
  }): Promise<void> => {
    try {
      const body: any = {
        Nome: data.nome,
        Email: data.email,
        Login: data.login,
        Ativo: data.ativo,
        IdCliente: data.idCliente,
        IdPerfil: data.idPerfil,
        TipoUsuario: data.tipoUsuario
      }

      // Adiciona token apenas se fornecida
      if (data.token !== undefined) {
        body.Token = data.token
      }

      // Adiciona tokenAtivo apenas se fornecida
      if (data.tokenAtivo !== undefined) {
        body.TokenAtivo = data.tokenAtivo
      }

      if (data.idsClientes !== undefined) {
        body.IdsClientes = data.idsClientes
      }

      const result = await axiosAuthInstance.put(`/usuario/${data.idUsuario}`, body)

      return result.data.usuario
    } catch (error) {
      throw error
    }
  }, [axiosAuthInstance])

  const isVelesUserApi = useCallback(async (data: {
    id: string
  }): Promise<boolean> => {
    await delay(1551)
    return false
  }, [])

  const changeUserPasswordApi = useCallback(async (data: {
    id: string
    password: string
  }): Promise<void> => {
    await delay(1551)
    return
  }, [])

  const sendRecoveryPasswordEmailApi = useCallback(async (data: {
    idUsuario: number
  }): Promise<{
    message: string
  }> => {
    try {
      const result = await axiosAuthInstance.post(`/usuario/${data.idUsuario}/recovery-password`)
      return result.data
    } catch (error) {
      throw error
    }
  }, [axiosAuthInstance])

  const generateTokenApi = useCallback(async (): Promise<{
    token: string
  }> => {
    try {
      const result = await axiosAuthInstance.get(`/usuario/generate-token`)
      return result.data
    } catch (error: any) {
      console.error('Erro ao gerar token:', error?.response?.data || error?.message)
      throw error
    }
  }, [axiosAuthInstance])

  const getClientesVelesSelecionadosVizualizacaoApi = useCallback(async (data: {
    idUsuario: number
  }): Promise<{
    idsClientes: number[]
    clientes: any[]
  }> => {
    try {
      const result = await axiosAuthInstance.get(`/usuario/${data.idUsuario}/clientes-veles-selecionados`)
      return result.data
    } catch (error: any) {
      throw error
    }
  }, [axiosAuthInstance])

  return {
    getUserByIdApi,
    getUserPerfilApi,
    getVendedoresApi,
    findUsuariosByIdClienteApi,
    createUserApi,
    updateUserApi,
    isVelesUserApi,
    changeUserPasswordApi,
    getAllUsuariosAtivosByIdClienteApi,
    sendRecoveryPasswordEmailApi,
    generateTokenApi,
    getClientesVelesSelecionadosVizualizacaoApi
  }
}
